"use strict";
import React, { forwardRef } from "react";
import classNames from "classnames";
export var SpinnerSize = /* @__PURE__ */ ((SpinnerSize2) => {
  SpinnerSize2[SpinnerSize2["Small"] = 16] = "Small";
  SpinnerSize2[SpinnerSize2["Medium"] = 32] = "Medium";
  SpinnerSize2[SpinnerSize2["Large"] = 64] = "Large";
  return SpinnerSize2;
})(SpinnerSize || {});
const Spinner = forwardRef(
  ({ size = 32 /* Medium */, style, className, primary, message }, ref) => {
    const strokeWidth = getStrokeWidth(size);
    const radius = size / 2;
    const offsetRadius = radius - strokeWidth / 2;
    const circumference = size * Math.PI;
    return /* @__PURE__ */ React.createElement("div", { className: classNames("spinner", className, { "spinner--primary": primary }), style }, message && /* @__PURE__ */ React.createElement("div", { className: "spinner__message" }, message), /* @__PURE__ */ React.createElement(
      "svg",
      {
        className: "spinner__element",
        fill: "none",
        strokeWidth,
        width: size,
        height: size,
        strokeLinecap: "round",
        viewBox: `${radius} ${radius} ${size} ${size}`,
        ref
      },
      /* @__PURE__ */ React.createElement("circle", { className: "spinner__background", cx: size, cy: size, r: offsetRadius, strokeOpacity: 0.2 }),
      /* @__PURE__ */ React.createElement(
        "circle",
        {
          className: "spinner__path",
          cx: size,
          cy: size,
          r: offsetRadius,
          strokeDasharray: `${circumference / 4} ${circumference}`,
          strokeDashoffset: circumference
        }
      )
    ));
  }
);
function getStrokeWidth(size) {
  switch (size) {
    case 16 /* Small */:
      return 3;
    case 32 /* Medium */:
      return 4;
    case 64 /* Large */:
      return 5;
    default:
      return 3;
  }
}
export default Spinner;
